// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2NMLk","title":"Header_title__1A_CB","side":"Header_side__2HxYb"};